module.exports = __webpack_public_path__ + "img/FeatureAgendaExampleCompressed.fd5a7d53.png";